import { Phone } from "lucide-react";

export function StickyCallButton() {
  return (
    <>
      <div className="h-16 md:hidden" aria-hidden="true" />
      <a
        href="tel:+36304787619"
        onClick={() => {
          if (typeof window !== "undefined" && typeof window.gtag === "function") {
            window.gtag("event", "call_click_sticky", { location: window.location.pathname });
          }
        }}
        className="fixed inset-x-0 bottom-0 z-40 flex h-16 items-center justify-center gap-2 bg-primary text-primary-foreground font-semibold uppercase tracking-wider shadow-2xl md:hidden"
      >
        <Phone className="h-5 w-5" /> Hívás · +36 30 478 7619
      </a>
    </>
  );
}
